import $ from 'jquery';

const faq = {
	init() {
		const $search = $(".__faq_search_input");

		if (!$search.length) {
			return;
		}

		const normalize = (value) => value
			.toString()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.toLowerCase();

		const $categories = $(".__contain_faq .__block_faq");
		const totalQuestions = $(".__contain_faq .__ul_faq > li").length;

		$search.on("input", (event) => {
			const query = normalize($(event.currentTarget).val().trim());
			let visibleQuestions = 0;

			$categories.each((categoryIndex, categoryElement) => {
				const $category = $(categoryElement);
				const $questions = $category.find(".__ul_faq > li");
				let categoryMatches = 0;

				$questions.each((questionIndex, questionElement) => {
					const $question = $(questionElement);
					const searchableText = normalize($question.find(".__question, .__answer").text());
					const matches = !query || searchableText.indexOf(query) !== -1;

					$question.toggle(matches);
					if (matches) {
						categoryMatches++;
					}
				});

				$category.toggle(categoryMatches > 0);
				$category.find(".__faq_category_count").text(`${categoryMatches} question${categoryMatches > 1 ? "s" : ""}`);

				if (query && categoryMatches > 0) {
					$category.addClass("_open");
					$category.children(".__faq_category_panel").show();
					$category.find(".__faq_category_toggle").attr("aria-expanded", "true");
				}

				visibleQuestions += categoryMatches;
			});

			$(".__faq_no_result").toggleClass("_show", visibleQuestions === 0);
			$(".__contain_faq").attr("aria-label", query
				? `${visibleQuestions} result${visibleQuestions > 1 ? "s" : ""} found`
				: `${totalQuestions} frequently asked questions`);
		});
	}
};

export default faq;
